<script setup>
import { ref, computed } from 'vue'
import { usePageStore } from '@/stores/app/page'

const props = defineProps({
  pages: Object,
})

const pageStore = usePageStore()

// State -----------------------------------------
const page = ref(pageStore.page)
const refreshPageTrigger = ref(pageStore.refreshPageTrigger)

// Getters ---------------------------------------

// Methods ---------------------------------------

// Events ----------------------------------------
pageStore.$onAction(({ name, store, args, after, onError }) => {
  console.log('[AppPageView] $onAction ->', name, args)
  // after((result) => {})
  // onError((error) => {})
})

pageStore.$subscribe((mutation, state) => {
  /* before update local state */
  console.log('[AppPageView] $subscribe ->', { ...state })
  /* update local state */
  page.value = state.page
  refreshPageTrigger.value = state.refreshPageTrigger
  /* after updated local state ... */
  // console.log('[AppPageView] updated')
})

// Main Setup ------------------------------------

// -----------------------------------------------
</script>

<template>
  <div class="container">
    <transition name="fade-page" mode="out-in" appear>
      <component class="page-view" :is="pages[page]" :key="refreshPageTrigger"></component>
    </transition>
  </div>
</template>

<style scoped>
/* ------------------------ */
.fade-page-enter-active,
.fade-page-leave-active {
  transition: opacity 0.4s ease;
}
.fade-page-enter-from,
.fade-page-leave-to {
  opacity: 0;
}

/* ----------------------------- */
.container {
  display: grid;
  /* border: 1px solid #f00; */
}

.page-view {
  grid-area: 1 / 1;
}

/* ------------------------ */
</style>
